<template>
  <div>
    <nav
      id="page-top"
      class="navbar navbar-expand navbar-dark navbar-color static-top"
    >
      <a
        class="navbar-brand mr-1 pointer text-white"
        @click="moveToProfile()"
        style="font-weight: bold"
        >Bono</a
      >

      <button
        class="btn btn-link btn-sm text-white order-1 order-sm-0"
        id="sidebarToggle"
        @click="hamburgerClick()"
      >
        <i class="fas fa-bars"></i>
      </button>

      <!-- Navbar Search -->
      <form
        class="d-none d-md-inline-block form-inline ml-auto mr-0 mr-md-3 my-2 my-md-0"
      >
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Search for..."
            aria-label="Search"
            aria-describedby="basic-addon2"
          />
          <div class="input-group-append">
            <button class="btn searchBtn-color" type="button">
              <i class="fas fa-search"></i>
            </button>
          </div>
        </div>
      </form>

      <!-- Navbar -->
      <ul class="navbar-nav ml-auto ml-md-0">
        <li class="nav-item dropdown no-arrow mx-1">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            id="alertsDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fas fa-bell fa-fw"></i>
            <span class="badge badge-danger">9+</span>
          </a>
          <div
            class="dropdown-menu dropdown-menu-right"
            aria-labelledby="alertsDropdown"
          >
            <a class="dropdown-item" href="#">Action</a>
            <a class="dropdown-item" href="#">Another action</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="#">Something else here</a>
          </div>
        </li>
        <li class="nav-item dropdown no-arrow mx-1">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            id="messagesDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fas fa-envelope fa-fw"></i>
            <span class="badge badge-danger">7</span>
          </a>
          <div
            class="dropdown-menu dropdown-menu-right"
            aria-labelledby="messagesDropdown"
          >
            <a class="dropdown-item" href="#">Action</a>
            <a class="dropdown-item" href="#">Another action</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="#">Something else here</a>
          </div>
        </li>
        <li class="">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            id="userDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {{ userName }}
            <i class="fas fa-user-circle fa-fw"></i>
          </a>
          <div
            class="dropdown-menu dropdown-menu-right"
            aria-labelledby="userDropdown"
          >
            <a class="dropdown-item" type="button">Settings</a>
            <a class="dropdown-item" type="button">Activity Log</a>
            <div class="dropdown-divider" type="button"></div>
            <a
              class="dropdown-item"
              href="#"
              data-toggle="modal"
              data-target="#logoutModal"
              >Logout</a
            >
          </div>
        </li>
      </ul>
    </nav>

    <div class="row">
      <div v-bind:class="{ sidebarwidth: !isActive }">
        <div id="wrapper">
          <!-- Sidebar -->
          <ul
            class="sidebar navbar-nav sidebar-color"
            v-bind:class="{ toggled: isActive }"
          >
            <li class="nav-item" id="menudashboard">
              <a class="nav-link" @click="dashboard()">
                <i class="fas fa-fw fa-tachometer-alt"></i>
                <span>Dashboard</span>
              </a>
            </li>
            <li
              class="nav-item"
              style="background-color: #023D54; display: none"
              id="menuorganization"
            >
              <a class="nav-link pointer" @click="organization()">
                <i class="fas fa-fw fa-chart-area"></i>
                <span>ორგანიზაცია</span></a
              >
            </li>
            <!-- <li class="nav-item" id="menumerchant">
              <a class="nav-link pointer" @click="merchant()">
                <i class="fas fa-fw fa-table"></i>
                <span>Merchant</span></a
              >
            </li>
            -->
            <li
              class="nav-item"
              id="menucashierLoyalty"
              style="background-color: #023D54; display: none"
            >
              <a class="nav-link pointer" @click="cashierLoyalty()">
                <i class="fas fa-fw fa-table"></i>
                <span>სალაროს ლოიალობის პირობები</span></a
              >
            </li>
            <li
              class="nav-item"
              id="menuproductLoyalty"
              style="background-color: #023D54; display: none"
            >
              <a class="nav-link pointer" @click="productLoyalty()">
                <i class="fas fa-fw fa-table"></i>
                <span>პროდუქტის ლოიალობის პირობები</span></a
              >
            </li>
            <li
              class="nav-item"
              id="menuproductCategory"
              style="background-color: #023D54; display: none"
            >
              <a class="nav-link pointer" @click="productCategory()">
                <i class="fas fa-fw fa-table"></i>
                <span>პროდუქტის კატეგორია</span></a
              >
            </li>
            <li
              class="nav-item"
              id="menuproductSubCategory"
              style="background-color: #023D54; display: none"
            >
              <a class="nav-link pointer" @click="productSubCategory()">
                <i class="fas fa-fw fa-table"></i>
                <span>პროდუქტის ქვეკატეგორია</span></a
              >
            </li>
            <li
              class="nav-item"
              id="menuproductSubSubCategory"
              style="background-color: #023D54; display: none"
            >
              <a class="nav-link pointer" @click="productSubSubCategory()">
                <i class="fas fa-fw fa-table"></i>
                <span>პროდუქტის ქვე ქვე კატეგორია</span></a
              >
            </li>
            <li
              class="nav-item"
              id="menuproductProperty"
              style="background-color: #023D54; display: none"
            >
              <a class="nav-link pointer" @click="productProperty()">
                <i class="fas fa-fw fa-table"></i>
                <span>პროდუქტის თვისებები</span></a
              >
            </li>
            <li
              class="nav-item"
              id="menuProducts"
              style="background-color: #023D54; display: none"
            >
              <a class="nav-link pointer" @click="Products()">
                <i class="fas fa-fw fa-table"></i>
                <span>პროდუქტი</span></a
              >
            </li>
            <li
              class="nav-item"
              id="menuProductSalet"
              style="background-color: #023D54; display: none"
            >
              <a class="nav-link pointer" @click="ProductSale()">
                <i class="fas fa-fw fa-table"></i>
                <span>პროდუქტის ფასდაკლება</span></a
              >
            </li>
            <li
              class="nav-item"
              id="menuProductBrand"
              style="background-color: #023D54; display: none"
            >
              <a class="nav-link pointer" @click="ProductBrand()">
                <i class="fas fa-fw fa-table"></i>
                <span>პროდუქტის ბრენდი</span></a
              >
            </li>
            <li
              class="nav-item"
              id="menuLegalBrandCategory"
              style="background-color: #023D54; display: none"
            >
              <a class="nav-link pointer" @click="LegalBrandCategory()">
                <i class="fas fa-fw fa-table"></i>
                <span>ლეგალ ბრენდის კატეგორია</span></a
              >
            </li>
            <li
              class="nav-item"
              id="menuLegalBrand"
              style="background-color: #023D54; display: none"
            >
              <a class="nav-link pointer" @click="LegalBrand()">
                <i class="fas fa-fw fa-table"></i>
                <span>ლეგალ ბრენდი</span></a
              >
            </li>
            <li
              class="nav-item"
              id="menuLottery"
              style="background-color: #023D54; display: none"
            >
              <a class="nav-link pointer" @click="Lottery()">
                <i class="fas fa-fw fa-table"></i>
                <span>ლატარია</span></a
              >
            </li>
            <li
              class="nav-item"
              id="menuLotteryMember"
              style="background-color: #023D54; display: none"
            >
              <a class="nav-link pointer" @click="LotteryMember()">
                <i class="fas fa-fw fa-table"></i>
                <span>ლატარიის წევრები</span></a
              >
            </li>
            <li
              class="nav-item"
              id="menuProductLoyaltyPrize"
              style="background-color: #023D54; display: none"
            >
              <a class="nav-link pointer" @click="ProductLoyaltyPrize()">
                <i class="fas fa-fw fa-table"></i>
                <span>პროდუქტის ლოიალურობა, პრიზები</span></a
              >
            </li>

            <li
              class="nav-item"
              id="menuProductMenuGroups"
              style="background-color: #1d7749; display: none"
            >
              <a class="nav-link pointer" @click="ProductMenuGroups()">
                <i class="fas fa-fw fa-table"></i>
                <span>პროდუქტის მენიუ ჯგუფი</span></a
              >
            </li>
            <li
              class="nav-item"
              id="menuSpecialItem"
              style="background-color: #1d7749; display: none"
            >
              <a class="nav-link pointer" @click="SpecialItem()">
                <i class="fas fa-fw fa-table"></i>
                <span>სპეციალური ნივთი</span></a
              >
            </li>
            <li
              class="nav-item"
              id="menuSpecialGroup"
              style="background-color: #1d7749; display: none"
            >
              <a class="nav-link pointer" @click="SpecialGroup()">
                <i class="fas fa-fw fa-table"></i>
                <span>სპეციალური ჯგუფი</span></a
              >
            </li>
            <li
              class="nav-item"
              id="menuLegalBrandMenuGroup"
              style="background-color: #1d7749; display: none"
            >
              <a class="nav-link pointer" @click="LegalBrandMenuGroup()">
                <i class="fas fa-fw fa-table"></i>
                <span>ლეგალ ბრენდის მენიუ ჯგუფი</span></a
              >
            </li>

            <li
              class="nav-item"
              id="menuUserManagement"
              style="background-color: #002e05; display: none"
            >
              <a class="nav-link pointer" @click="UserManagement()">
                <i class="fas fa-fw fa-table"></i>
                <span>მომხმარებლის მენეჯმენტი</span></a
              >
            </li>
            <li
              class="nav-item"
              id="menuRoleManagement"
              style="background-color: #002e05; display: none"
            >
              <a class="nav-link pointer" @click="RoleManagement()">
                <i class="fas fa-fw fa-table"></i>
                <span>როლების მენეჯმენტი</span></a
              >
            </li>
            <li
              class="nav-item"
              id="menuChangePassword"
              style="background-color: #002e05; display: none"
            >
              <a class="nav-link pointer" @click="ChangePassword()">
                <i class="fas fa-fw fa-table"></i>
                <span>პაროლის შეცვლა</span></a
              >
            </li>
            <li
              class="nav-item"
              id="menuAppAccountManagement"
              style="background-color: #002e05; display: none"
            >
              <a class="nav-link pointer" @click="AppAccountManagement()">
                <i class="fas fa-fw fa-table"></i>
                <span>აპლიკაციის მომხმარებლების მენეჯმენტი</span></a
              >
            </li>
            <li
              class="nav-item"
              id="menuQRGenerator"
              style="background-color: #002e05; display: none"
            >
              <a class="nav-link pointer" @click="GenerateQR()">
                <i class="fas fa-fw fa-table"></i>
                <span>QR გენერატორი</span></a
              >
            </li>
            <li
              class="nav-item"
              id="menuCardLoyalty"
              style="background-color: #002e05; display: none"
            >
              <a class="nav-link pointer" @click="CardLoyalty()">
                <i class="fas fa-fw fa-table"></i>
                <span>ლოიალობის ბარათები</span></a
              >
            </li>
            <li
              class="nav-item"
              id="menuNewApplications"
              style="background-color: #002e05; display: none"
            >
              <a class="nav-link pointer" @click="NewApplications()">
                <i class="fas fa-fw fa-table"></i>
                <span>მიღებული განაცხადები</span></a
              >
            </li>
            <li
              class="nav-item"
              id="menuFinishedApplications"
              style="background-color: #002e05; display: none"
            >
              <a class="nav-link pointer" @click="FinishedApplications()">
                <i class="fas fa-fw fa-table"></i>
                <span>დასრულებული განაცხადები</span></a
              >
            </li>
            <li
              class="nav-item"
              id="menuPartners"
              style="background-color: #002e05; display: none"
            >
              <a class="nav-link pointer" @click="Partners()">
                <i class="fas fa-fw fa-table"></i>
                <span>პარტნიორი ორგანიზაციები</span></a
              >
            </li>
            <li
              class="nav-item"
              id="menuWhereToCollect"
              style="background-color: #002e05;"
            >
              <a class="nav-link pointer" @click="WhereToCollect()">
                <i class="fas fa-fw fa-table"></i>
                <span>სად დავაგროვო</span></a
              >
            </li>
            <li
              class="nav-item"
              id="menuChargeOperations"
              style="background-color: #002e05; display: none"
            >
              <a class="nav-link pointer" @click="ChargeOperations()">
                <i class="fas fa-fw fa-table"></i>
                <span>გადახდის ოპერაციები</span></a
              >
            </li>
            <li
              class="nav-item"
              id="menuCartManagement"
              style="background-color: #002e05; display: none"
            >
              <a class="nav-link pointer" @click="CartManagement()">
                <i class="fas fa-fw fa-table"></i>
                <span>კალათის ოპერატორის მართვის პანელი</span></a
              >
            </li>
            <!--
            <li class="nav-item" id="menuProductLoyalty">
              <a class="nav-link pointer" @click="ProductLoyalty()">
                <i class="fas fa-fw fa-table"></i>
                <span>პროდუქტის ლოიალურობა</span></a
              >
            </li>
            -->
          </ul>
        </div>
      </div>
      <div class="blabla col-sm-8 bla" v-bind:class="{ blu: isActive }">
        <router-view></router-view>
      </div>
    </div>
    <!-- /#wrapper -->

    <!-- Scroll to Top Button-->
    <a class="scroll-to-top rounded" href="#page-top">
      <i class="fas fa-angle-up"></i>
    </a>

    <!-- Logout Modal-->
    <div
      class="modal fade"
      id="logoutModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Ready to Leave?</h5>
            <button
              class="close"
              type="button"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            Select "Logout" below if you are ready to end your current session.
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-secondary"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <a class="btn btn-primary" href="/" @click="clearToken()">Logout</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../assets/js/sb-admin.min.js";
import "../../assets/vendor/datatables/jquery.dataTables.js";
import "../../assets/vendor/datatables/dataTables.bootstrap4.js";
import "../../assets/js/demo/datatables-demo.js";

export default {
  name: "navigation",
  data() {
    return {
      isActive: false,
      userName: "admin",
    };
  },
  mounted: async function () {
    $("ul.navbar-nav > li").click(function (e) {
      $("ul.navbar-nav > li").removeClass("active");
      $(this).addClass("active");
      localStorage.setItem("activePage", this.id);
    });

    var activePage = localStorage.getItem("activePage");
    if (activePage) {
      $("#" + activePage).addClass("active");
    }

    this.userName = localStorage.getItem("userName");

    var menuItems = await this.$http.getMenuItems();

    menuItems.data.res.forEach((element) => {
      document.getElementById(element).style.display = "";
    });
  },
  methods: {
    dashboard() {
      this.$router.push("/dashboard");
    },
    organization() {
      this.$router.push("/organizations");
    },
    merchant() {
      this.$router.push("/merchant");
    },
    productCategory() {
      this.$router.push("/productcategory");
    },
    productSubCategory() {
      this.$router.push("/productsubcategory");
    },
    productSubSubCategory() {
      this.$router.push("/productsubsubcategory");
    },
    productProperty() {
      this.$router.push("/productproperty");
    },
    cashierLoyalty() {
      this.$router.push("/cashierloyalty");
    },
    productLoyalty() {
      this.$router.push("/productloyalty");
    },
    Products() {
      this.$router.push("/products");
    },
    ProductSale() {
      this.$router.push("/productsale");
    },
    //ProductLoyalty() {
    //this.$router.push("/productloyalty");
    //},
    moveToProfile() {
      this.$router.push("/profile");
    },
    hamburgerClick() {
      this.isActive = !this.isActive;
    },
    ProductMenuGroups() {
      this.$router.push("/productmenugroup");
    },
    ProductBrand() {
      this.$router.push("/productbrand");
    },
    SpecialItem() {
      this.$router.push("/specialitem");
    },
    SpecialGroup() {
      this.$router.push("/specialgroup");
    },
    LegalBrandMenuGroup() {
      this.$router.push("/legalbrandmenugroup");
    },
    LegalBrandCategory() {
      this.$router.push("/legalbrandcategory");
    },
    LegalBrand() {
      this.$router.push("/legalbrand");
    },
    Lottery() {
      this.$router.push("/lottery");
    },
    LotteryMember() {
      this.$router.push("/lotterymember");
    },
    ProductLoyaltyPrize() {
      this.$router.push("/productloyaltyprize");
    },
    RoleManagement() {
      this.$router.push("/roleManagement");
    },
    UserManagement() {
      this.$router.push("/userManagement");
    },
    ChangePassword() {
      this.$router.push("/changePassword");
    },
    AppAccountManagement() {
      this.$router.push("/appAccountManagement");
    },
    GenerateQR() {
      this.$router.push("/qrGenerator");
    },
    CardLoyalty() {
      this.$router.push("/cardLoyalty");
    },
    NewApplications() {
      this.$router.push("/NewApplication");
    },
    FinishedApplications() {
      this.$router.push("/FinishedApplication");
    },
    Partners() {
      this.$router.push("/Partner");
    },
    WhereToCollect() {
      this.$router.push("/WhereToCollect");
    },
    ChargeOperations() {
      this.$router.push("/ChargeOperation");
    },
    CartManagement() {
      this.$router.push("/CartManagement");
    },
    clearToken() {
      localStorage.removeItem("token");
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
@import "../../assets/scss/_mixins.scss";
@import "../../assets/scss/_navbar.scss";
@import "../../assets/scss/sb-admin.scss";
@import "../../assets/css/sb-admin.css";
@import "../../assets/vendor/datatables/dataTables.bootstrap4.css";

.pointer {
  cursor: pointer;
  color: white !important;
}

.nav-item :hover {
  background-color: #04958a;
}

.nav-item :after {
  background-color: #04958a;
}

.sidebatHeight {
  height: 100%;
}

.sidebarwidth {
  width: 90px;
  background-color: #023D54;
}

.bla {
  margin-left: auto;
  margin-right: auto;
}

.blabla {
  width: 75%;
}

.navbar-color {
  background-color: #023D54;
}

.sidebar-color {
  background-color: #023D54;
  color: white;
}

.searchBtn-color {
  background-color: #04958a;
  color: white;
}

@media only screen and (max-width: 500px) {
  .bla {
    margin-left: 0px;
    margin-right: 0px;
    padding-left: 0px;
    padding-right: 0px;
  }

  .blu {
    padding-left: 20px;
    padding-right: 10px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/routing/navigation.vue